import React, { useEffect } from 'react';
import { ThemeProvider as Provider } from 'react-jss';
import { Theme } from './Theme';
import FontLoader from 'webfontloader';
import { DimensionsProvider } from '../../context/DimensionsContext';
export var ThemeProvider = function ThemeProvider(_ref) {
  var _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? Theme : _ref$theme,
      children = _ref.children;
  useEffect(function () {
    FontLoader.load({
      google: {
        families: ['Ubuntu:300,400,500,700']
      }
    });
  }, []);
  return React.createElement(Provider, {
    theme: theme
  }, React.createElement(DimensionsProvider, null, children));
};